import { useEffect, useState } from 'react'
import AnimationLayout from './components/AnimationLayout'

interface Badge {
  name: string
  emoji: string
  description: string
  points_awarded: number
}

interface Props {
  animation: { id: number; name: string; description: string }
  badge: Badge
  all_animations: { id: number; name: string }[]
}

export default function Animation24({ animation, badge, all_animations }: Props) {
  const [showBadge, setShowBadge] = useState(false)

  useEffect(() => {
    setTimeout(() => setShowBadge(true), 200)
  }, [])

  return (
    <AnimationLayout animation={animation} allAnimations={all_animations}>
      <style>{`
        @keyframes elasticDrop {
          0% {
            transform: translateY(-300px) scaleY(1.5) scaleX(0.8);
            opacity: 0;
          }
          30% {
            transform: translateY(30px) scaleY(0.7) scaleX(1.3);
            opacity: 1;
          }
          45% {
            transform: translateY(-60px) scaleY(1.2) scaleX(0.9);
          }
          60% {
            transform: translateY(15px) scaleY(0.85) scaleX(1.1);
          }
          75% {
            transform: translateY(-20px) scaleY(1.05) scaleX(0.95);
          }
          85% {
            transform: translateY(5px) scaleY(0.95) scaleX(1.02);
          }
          100% {
            transform: translateY(0) scaleY(1) scaleX(1);
          }
        }
        @keyframes shadowPulse {
          0%, 100% {
            transform: scaleX(1);
            opacity: 0.3;
          }
          30% {
            transform: scaleX(1.5);
            opacity: 0.5;
          }
          45% {
            transform: scaleX(0.8);
            opacity: 0.2;
          }
        }
        .elastic-drop {
          animation: elasticDrop 1.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
        }
        .shadow-pulse {
          animation: shadowPulse 1.5s ease-out forwards;
        }
      `}</style>

      <div className="flex flex-col items-center justify-center min-h-[50vh] sm:min-h-[60vh]">
        {/* Ombre au sol */}
        <div className={`absolute mt-56 w-32 h-4 bg-black/20 rounded-full blur-md ${showBadge ? 'shadow-pulse' : 'opacity-0'}`} />

        {/* Badge qui tombe */}
        <div className={`relative z-10 ${showBadge ? 'elastic-drop' : 'opacity-0'}`}>
          <div className="w-32 h-32 sm:w-44 sm:h-44 bg-tessan-cream rounded-2xl flex items-center justify-center shadow-2xl shadow-tessan-yellow/50">
            <span className="text-6xl sm:text-8xl">{badge.emoji}</span>
          </div>
        </div>

        <div className={`mt-8 text-center transition-all duration-700 delay-1500 ${showBadge ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          <div className="text-2xl sm:text-4xl font-black text-tessan-yellow">{badge.name}</div>
          <div className="text-lg sm:text-xl text-tessan-cream mt-2">+{badge.points_awarded} points</div>
          <div className="text-tessan-cream/70 mt-4 max-w-[280px] sm:max-w-xs">{badge.description}</div>
        </div>
      </div>
    </AnimationLayout>
  )
}
